import React, {
	useEffect, useState
} from 'react';
import {useTranslation} from "react-i18next";

import { Line } from 'react-chartjs-2';
import { Chart as ChartJS } from 'chart.js/auto'

const GraphLinearView = ({data}) => {

	const graphOptions = {
		responsive: true,
		scales: {
		}
	};

	const {t}  = useTranslation();
	const [labels, setLabels] = useState([]);
	const [datasets, setDatasets] = useState([]);

	const dynamicColor = () => {
			var letters = '0123456789ABCDEF'.split('');
			var color = '#';
			for (var i = 0; i < 6; i++ ) {
			color += letters[Math.floor(Math.random() * 16)];
		}
		return color;
	}

	const graphData = {
		labels,
		datasets: datasets,
	};

	useEffect(() => {
		let categories = [];

		setLabels(data.Dates);

		for (let i in data.ParkingZones) {
			let parkingZone = data.ParkingZones[i];

			let category = [];
			for (let j in data.Dates) {
				let date = data.Dates[j];

				let rs =data.Items.filter(x => x.Date == date && x.ParkingZoneId == parkingZone.Id);

				if (rs.length > 0) {
					category.push(rs[0].TotalEventCount);
				} else {
					category.push(0);
				}
			}

			const color = dynamicColor();
			categories.push({
				label: parkingZone.Name,
				data: category,
				backgroundColor: color,
				borderColor: color,
			});
		}

		setDatasets(categories);
	}, [data]);

	return (
		<>
		{datasets && <Line options={graphOptions} data={graphData} />}
		</>
	);
};

export default GraphLinearView;